module.exports = __webpack_public_path__ + "img/video.483e143b.jpg";